// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1xK8F","consentsList":"PatientConsents_consentsList__1288v","consentsListEmpty":"PatientConsents_consentsListEmpty__3TyJS"};